<div class="vw-100">
    <div class="example-container">
        <app-sidebar (sidebarToggled)="onSidebarToggle($event)"></app-sidebar>
        <div class="container-fluid">
            <app-header  #headerRef></app-header>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
